<template>
  <div class="input-modal-wrapper" @click.self="dropdown = false">
    <div class="input-modal" @click.self="dropdown = false">
      <span class="mck close" @click.prevent="close()">F</span>
      <form>
        <h2 v-if="!this.obj">НОВ ЧОВЕКОЧАС</h2>
        <h2 v-else>РЕДАКТИРАЙ ЧОВЕКОЧАС</h2>
        <br />
        <div class="inputs">
          <!-- COMMON INPUTS -->
          <div class="input-wrapper">
            <span class="mck2">s</span>
            <input
              id="inputPositionField"
              type="text"
              placeholder="Длъжност"
              v-model="inputPosition.name"
              :disabled="true"
              @keydown.enter.prevent="save()"
            />
          </div>
          <div class="input-wrapper">
            <span class="mck2">t</span>
            <input
              id="inputQuantityField"
              type="number"
              placeholder="ЧЧ-бр"
              v-model="inputQuantity"
              @keydown.enter.prevent="save()"
            />
          </div>
        </div>
        <label class="input-label">Част</label>
        <div class="parts-wrapper">
          <div class="parts-toggle" @click="dropdown = !dropdown">
            <span class="mck">i</span>
            <p v-if="!newPart">ЧАСТ: {{ inputPart }}</p>
            <input
              type="text"
              v-model="inputPart"
              @blur="
                (newPart = false),
                  (dropdown = false),
                  !inputPart.length ? (inputPart = obj.part) : null
              "
              ref="newPartInput"
              :placeholder="newPart ? `Име на новата част` : null"
              v-else
            />
            <div class="parts-dropdown" v-if="dropdown && !newPart">
              <p
                v-for="(p, i) in parts"
                :key="`p-${i}`"
                @click.stop="(inputPart = p), (dropdown = false)"
              >
                {{ p }}
              </p>
            </div>
          </div>
          <a
            class="parts-new"
            @click="activateNewPartInput()"
            title="Добави нова част"
            v-if="!newPart"
          >
            <span>+</span>
          </a>
        </div>

        <div class="input-modal-actions">
          <div>
            <!-- JUST AND EMPTY DIV FOR THE SPACE-BETWEEN RULE TO WORK -->
          </div>
          <div class="btns">
            <button class="btn btn-close" @click.prevent="close()">
              <span class="mck">F</span>
              Отказ
            </button>
            <!-- BUTTON ACCEPT FOR MATERIAL/ACTIVITY-->
            <button
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="save()"
            >
              <span class="mck">Y</span>
              Запази
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: ['obj', 'parts', 'type'],
  data() {
    return {
      inputName: '',
      inputPosition: '',
      inputPart: '',
      inputQuantity: undefined,
      dropdown: false,
      newPart: false,
    };
  },
  methods: {
    activateNewPartInput() {
      this.inputPart = '';
      this.newPart = true;
      this.$nextTick(() => {
        this.$refs.newPartInput.focus();
      });
    },
    save() {
      if (this.isValid()) {
        if (!this.obj) {
          this.$emit('create', {
            // position: this.inputPosition,
            quantity: this.inputQuantity || 0,
            part: this.inputPart,
            isAdditional: true,
          });
        } else {
          this.$emit('edit', {
            // position: this.inputPosition,
            quantity: this.inputQuantity || 0,
            part: this.inputPart,
          });
        }
        this.close();
      }
    },
    // VALIDATE INPUTS
    isValid() {
      // if (!this.inputPosition) {
      //   this.$snotify.error('въведете длъжност');
      //   return false;
      // }
      if (!this.inputQuantity) {
        this.$snotify.error('въведете ЧЧ-бр');
        return false;
      }
      if (!this.inputPart) {
        this.$snotify.error('изберете съществуваща част или въведете нова');
        return false;
      }
      return true;
    },
    close() {
      this.$emit('close');
    },
    escape(e) {
      if (e.code === 'Escape') {
        this.close();
      }
    },
  },
  mounted() {
    if (this.obj) {
      this.inputPosition = this.obj.position;
      this.inputQuantity = this.obj.quantity;
      this.inputPart = this.obj.part;
    }

    window.addEventListener('keydown', this.escape);
  },
  destroyed() {
    window.removeEventListener('keydown', this.escape);
  },
};
</script>

<style scoped>
.input-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
.input-modal {
  background-color: #fff;
  border-radius: 4px;
  /* border-top: 10px solid #e65100; */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  /* overflow: auto; */
  padding: 15px 20px 0;
  position: relative;
  /* width: 600px; */
}
.close {
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  padding: 6px;
  position: absolute;
  right: 14px;
  top: 9px;
  transition: all 0.3s;
}
.close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.input-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.input-modal-actions {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.textarea-wrapper {
  width: 100%;
  margin-bottom: 0;
  max-width: 100%;
}
.textarea-wrapper .mck {
  top: 15px;
}
.textarea-wrapper textarea {
  background-color: #deecf9;
  color: #005a9e;
  font-family: 'Google Sans', Helvetica, Arial, sans-serif;
  font-weight: 700;
  min-height: 60px;
  padding-top: 6px;
  resize: vertical;
  width: 100%;
}
.input-wrapper .mck,
.input-wrapper .mck2,
.users-list .mck {
  color: #005a9e;
}
.input-wrapper input {
  color: #005a9e;
  font-weight: 700;
}

.input-wrapper textarea::placeholder,
.input-wrapper input::placeholder {
  font-weight: 400;
}
.input-wrapper input,
.users-list {
  background-color: #deecf9;
}
.invalid .mck {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.inputs {
  display: flex;
  margin-top: 7px;
}
.input-wrapper {
  margin-right: 1em;
  /* margin-bottom: 1em; */
}
.input-wrapper:last-child {
  margin-right: 0px;
  /* margin-bottom: 0px; */
}
.parts-wrapper {
  display: flex;
  width: 100%;
}
.parts-toggle {
  align-items: center;
  background-color: #deecf9;
  color: #005a9e;
  font-weight: 700;
  border-radius: 4px;
  display: flex;
  height: 35px;
  padding: 0 10px;
  position: relative;
  width: 100%;
}
.parts-toggle .mck {
  font-size: 16px;
  font-weight: 400;
  margin-right: 7px;
}
.parts-toggle > input {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  border-bottom: 2px dashed #005a9e;
  width: 100%;
}
.parts-dropdown {
  background-color: #deecf9;
  border-radius: 4px;
  left: 0;
  max-height: 15vh;
  overflow: auto;
  position: absolute;
  top: calc(100% + 5px);
  width: 100%;
}
.parts-dropdown p {
  cursor: pointer;
  padding: 5px 10px;
}

.parts-dropdown p:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.parts-new {
  align-items: center;
  background-color: #005a9e;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 30px;
  height: 35px;
  justify-content: center;
  margin-left: 10px;
  min-width: 35px;
  transition: all 0.3s;
  width: 35px;
}
.parts-new span {
  margin-top: -2px;
}
.parts-new:hover {
  opacity: 0.8;
}
form > h2 {
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}

.hide {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .btn.btn-close {
    margin-bottom: 5px;
  }
}
@media screen and (max-width: 650px) {
  .input-modal {
    width: 90%;
  }
}
@media screen and (max-width: 450px) {
  .inputs {
    flex-direction: column;
  }
  .input-wrapper {
    margin-right: 0px;
  }
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-close {
    margin-bottom: 10px;
  }
}
</style>
